package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

val SpinnerStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("border", "2px solid ${Palette.borderSubtle.cssRgb()}")
            property("animation", "sb-spin 0.7s linear infinite")
        }
    }
}

@Composable
fun Spinner(
    modifier: Modifier = Modifier,
    sizePx: Int = 16,
    color: CSSColorValue = Palette.textSecondary,
    ariaLabel: String = "Loading",
    trackColor: CSSColorValue = Palette.borderSubtle,
) {
    Div(
        attrs = SpinnerStyle.toModifier()
            .width(sizePx.px)
            .height(sizePx.px)
            .borderRadius(Radius.full)
            .styleModifier {
                property("border-color", trackColor.cssRgb())
                property("border-top-color", color.cssRgb())
            }
            .then(modifier)
            .toAttrs {
                attr("role", "status")
                attr("aria-label", ariaLabel)
            },
    )
}

@InitSilk
fun initSpinnerKeyframes(ctx: InitSilkContext) {
    ctx.stylesheet.registerKeyframes("sb-spin") {
        from { Modifier.styleModifier { property("transform", "rotate(0deg)") } }
        to { Modifier.styleModifier { property("transform", "rotate(360deg)") } }
    }
}
